import { LOCAL_STORAGE_CONSTANTS } from '../constants/api.constants';

export const getCountiesFromStorage = () => {
  const counties = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.COUNTIES);
  const parsedCounties = counties ? JSON.parse(counties) : [];
  return parsedCounties;
};
